import C from "okpay/util/Constants";

export default () =>
	({
		// imported
		// ---------

		productId: 0,
		product: {
			// this needs a child list of `options`, which is a list of prod options
			options: [
				{
					name: "",
					price: "",
					units: "",
					description: "",
					data: "",
					paypalLink: "",
				},
			],
		},

		creditCard: {},
		paypal: {},
		hasCreditCard: false,
		hasPaypal: false,
		useBillingInfo: false,
		isOpen: false,

		email: "",
		vatId: 0,
		vatRate: 0,
		taxRate: 0,
		isUS: 0,
		currencySymbol: 0,

		cf: [],

		// app state
		// ---------

		isLoading: false,

		// after they submit, but before they respond to errors
		hasSubmitted: false,

		// when the ajax call is actually running
		isSubmitting: false,
		isSuccessful: false,
		billingType: C.billingTypes.card,
		isActive: false,
		fakePayment: null,
		dismissedAdditionalPromo: false,
		openPaypalAgain: false,

		// form elements
		// ---------

		name: "",
		zipCode: "",
		cardNumber: "",
		securityCode: "",
		expiration: "",
		address: "",

		// errors thereof
		// ---------

		nameError: null,
		zipCodeError: null,
		cardNumberError: null,
		securityCodeError: null,
		expirationError: null,
		addressError: null,
		otherError: null,

		billingError: null,

		// derived elements
		// ---------

		isPaymentValid: false,
		cardType: null,
		expirationDate: null,
		firstName: "",
		lastName: "",
		selectedOption: {},

		// from dom
		// ---------

		width: 0,
		height: 0,
	});



// WEBPACK FOOTER //
// ./src/reflux/okpay/stores/getInitialState.js